import { typoM } from 'pages/selections/styles';

interface IStylesOptions {
  maxWidth?: string;
  modalWidth?: string;
}

export const fontStyles = {
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontWeight: 400,
};

export const typoSM = {
  ...fontStyles,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '146%',
};

export const actionBtn = {
  ...typoSM,
  textTransform: 'capitalize',
  border: '1px solid #4D6EF5',
  borderRadius: '8px',
  height: 'unset',
  padding: '12px 16px',
};

export const getStyles = (options?: IStylesOptions) => {
  const { maxWidth = '650px', modalWidth = '1250px' } = options ?? {};

  return {
    dialog: {
      '& .MuiPaper-root': {
        maxWidth: maxWidth,
        width: '100%',
        borderRadius: '12px',
      },
      '&.size-m .MuiPaper-root': {
        maxWidth: modalWidth,
      },
      '&.apply-selections-dialog .MuiPaper-root': {
        maxWidth: '95%',
        maxHeight: '95%',
        minHeight: '500px',
        width: '100%',
        borderRadius: '12px',
        overflow: 'hidden',
      },
      '&.fullwidth .MuiPaper-root': {
        width: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
      },
    },
    selectionDialogHeaderContainer: {
      padding: '40px',
      paddingBottom: '20px',
      borderBottom: '1px solid #f3f4f9',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    selectionDialogTitleWrapper: {
      display: 'flex',
      flexDirection: 'column',
    },
    dialogTitleWrapper: {
      padding: '40px',
      paddingBottom: '20px',
      borderBottom: '1px solid #f3f4f9',
      position: 'relative',
    },
    dialogTitle: {
      ...fontStyles,
      fontSize: '24px',
      lineHeight: '136%',
      color: '#23252F',
      textTransform: 'capitalize',
      '&.MuiButtonBase-root': {
        textTransform: 'capitalize',
        background: 'transparent',
        '&:hover, &:focus, &:active': {
          background: 'transparent',
        },
      },
    },
    dialogSubtitle: {
      ...typoSM,
      color: '#6e707a',
    },
    closeIconBtn: {
      position: 'absolute',
      right: '16px',
      top: '16px',
      '&.MuiButtonBase-root': {
        textTransform: 'capitalize',
        background: 'transparent',
        '&:hover, &:focus, &:active': {
          background: 'transparent',
        },
        color: '#23252F',
      },
    },
    dialogContent: {
      padding: '20px 40px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      overflowX: 'hidden',

      '& form': {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      },
      '& ::-webkit-inner-spin-button, & ::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '&.scrollable': {
        maxHeight: '680px',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          border: 'none',
          width: '11px',
          height: '11px',
        },

        '&::-webkit-scrollbar-track': {
          backgroundColor: '#fff',
          border: 'none',
          height: '10px',
        },

        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#D4D6E0',
          width: '2px',
          borderRadius: '6px',
          cursor: 'pointer',
        },
      },
    },
    actions: {
      padding: '20px 0',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '12px',
      '& .btn': {
        ...actionBtn,
        color: '#4D6EF5',
        backgroundColor: '#fff',
        '&:hover': {
          opacity: '0.8',
        },
      },
      '& .filled-btn': {
        color: '#fff',
        backgroundColor: '#4D6EF5',
        '&:hover': {
          color: '#fff',
          backgroundColor: '#4D6EF5',
          opacity: '0.8',
        },
      },
    },
    selectPaper: {
      padding: '4px 0',
      '& ul': {
        overflowY: 'auto',
      },
      '& .add-new': {
        padding: '0',
        marginTop: '4px',
        borderTop: '1px solid #F3F4F9',
      },
      '& .add-new-btn': {
        margin: '4px 2px',
        padding: '14px 16px',
        ...typoM,
        color: '#4D6EF5',
        textTransform: 'capitalize',
        '& .MuiButton-startIcon': {
          marginLeft: 0,
          '& svg': {
            width: '16px',
            height: '16px',
          },
        },
        '&:hover, &:focus, &:active': {
          background: 'transparent',
        },
      },
    },
    selectOptions: {
      margin: 0,
    },
    tooltipPopperProps: {
      '& .MuiTooltip-tooltip': {
        color: '#23252F',
        background: '#fff',
        boxShadow: '0px 4px 10px rgba(35, 37, 47, 0.1), 1px 2px 2px rgba(35, 37, 47, 0.04)',
        borderRadius: '12px',
        maxWidth: '600px',
        padding: 'unset',
      },
      '& .MuiTooltip-tooltipPlacementRight': {
        marginLeft: '8px !important',
        padding: '0',
      },
    },

    radioConatiner: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: '32px',
    },

    radio: {
      color: '#4D6EF5',
      '&.Mui-checked': {
        color: '#4D6EF5',
      },
    },

    radioLabel: {
      fontFamily: 'Inter',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '18px',
      color: '#6E707A',
    },
  };
};
